validateForm({
  selector: '#sign_in_form',
  rules: {
    email: {
      required: true,
      email: true
    },
    password: {
      required: true,
      minlength: 6
    }
  },
  submitHandler: function (form) {
    (async () => {
      var thisForm = $(form);
      const formData = new FormData(thisForm[0])
      if (grecaptcha && thisForm.attr('grecaptcha')) {
        const token = await grecaptcha.execute(global.CAPTCHA_PUBLIC_KEY, { action: thisForm.attr('id') });
        formData.set('reCAPTCHA', token)
      }
      $.ajax({
        url: thisForm.attr('action'),
        data: formData,
        method: thisForm.attr('method'),
        success: function (data) {
          if (!data.success) {
            removeErrors(form);
            showNotificationPopup(data.message, 'error');
          }
          if (data && data.redirect) {
            window.location = data.redirect;
          }
          if (data && data.view) {
            if (!$('#restore_user')[0]) {
              $(document.body).append($(data.view));
            } else {
              $('#restore_user').replaceWith($(data.view));
            }
          }
        }
      })
    })()
  }
})

validateForm({
  selector: '#sign_up_form',
  rules: {
    email: {
      required: true,
      email: true
    },
    first_name: {
      required: true
    },
    'phones[]': {
      required: true
    },
    last_name: {
      required: true
    },
    password: {
      required: true,
      minlength: 6
    },
    role_id: {
      required: true,
    },
    terms: {
      required: true
    }
  }
})

validateForm({
  selector: '#create_agent',
  rules: {
    email: {
      required: true,
      email: true
    },
    firstName: {
      required: true
    },
    lastName: {
      required: true
    },
    password: {
      required: true,
      minlength: 6
    },
    password_confirmation: {
      required: true,
      minlength: 6,
      equalTo: '[name="password"]'
    }
  }
})

validateForm({
  selector: '#reset_password',
  rules: {
    password: {
      required: true,
      minlength: 6
    },
    password_confirmation: {
      required: true,
      equalTo: '[name="password"]',
      minlength: 6
    }
  }
})

validateForm({
  selector: '#forgot_password',
  rules: {
    email: {
      required: true,
      email: true
    }
  },
  // submitHandler: async function (form) {
  //   var thisForm = $(form);
  //   $.ajax({
  //     url: thisForm.attr('action'),
  //     data: new FormData(thisForm[0]),
  //     method: thisForm.attr('method'),
  //     success: function (data) {
  //       if (data && data.success) {
  //         $('[popup_id="check_email_popup"]').removeAttr('hidden').addClass('active');
  //       } else {
  //         showNotificationPopup(data.message, 'error');
  //       }
  //     }
  //   });
  // }
});

validateForm({
  selector: '#network_form',
  rules: {
    name: {
      required: true,
    },
  }
})

validateForm({
  selector: '#listing_promotion',
  rules: {
    'entities[]': {
      required: true,
    },
    plan_id: {
      required: true,
    },
  },
  submitHandler: function (form) {
    var thisForm = $(form);
    $.ajax({
      url: thisForm.attr('action'),
      data: new FormData(thisForm[0]),
      method: thisForm.attr('method'),
      success: function (data) {
        if (data && data.success) {
          $('.select-listing.active').removeClass('active');
        }
      }
    });
  }
});

validateForm({
  selector: '#send_files_to_email',
  rules: {
    email: {
      required: true,
      email: true
    },
  },
  submitHandler: function (form) {
    var thisForm = $(form);
    $.ajax({
      url: thisForm.attr('action'),
      data: new FormData(thisForm[0]),
      method: thisForm.attr('method'),
      success: function (data) {
        if (data && data.success) {
          $('[popup_id="download_flyer"]').attr('hidden', 'hidden').removeClass('active');
          showNotificationPopup(data.message, 'success');
        }
      }
    });
  }
});

validateForm({
  selector: '#reports',
  rules: {
    name: {
      required: true,
      normalizer: function (value) {
        return $.trim(value);
     }
    }
  },
})